import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import ApiClient from "../services/api-client"
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import moment from 'moment'
import { VIVA_VIEW_TRANSACTION } from '../util/constants';
import { CustomConfirmAlert } from '../components/custom-confirm-alert';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { toast } from "react-toastify";
import {useNavigate} from 'react-router-dom';
import ActionsRenderer from '../components/aggrids/aggrid-cell-renderers/actions-renderer';
import useStore from '../hooks/useStore';
import { logout, get2FAStatus, setup2FA, enable2FA, disable2FA } from '../util/AuthUtils';
import { QRCodeSVG } from 'qrcode.react';



const DateRenderer = forwardRef((props, ref) => {

  const [val, setVal] = useState(props.value);

  useImperativeHandle(ref, () => {
    return {
      refresh(params) {
        var val = props.getValue();
        if (val !== undefined) {
          setVal(val);
        }
      }
    };

  });
  return (

    <span>{val ? moment(val).format('DD/MM/YYYY hh:mm') : ""}</span>
  );
});

const PackageProgressBar = ({ leftLimit, rightLimit, currentCount }) => {
  if (leftLimit == null || rightLimit == null) return null;
  const range = rightLimit - leftLimit;
  const progress = Math.min(Math.max(currentCount - leftLimit, 0), range);
  const pct = range > 0 ? (progress / range) * 100 : 0;

  return (
    <div style={{ marginTop: 14 }}>
      <div style={{ position: 'relative', height: 16, borderRadius: 8, background: 'rgba(255,255,255,0.2)', overflow: 'hidden' }}>
        <div style={{
          height: '100%',
          width: `${pct}%`,
          background: 'rgba(255,255,255,0.85)',
          borderRadius: 8,
          transition: 'width 0.5s ease',
        }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}>
        <span style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.65)' }}>{leftLimit}</span>
        <span style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>{currentCount} / {rightLimit}</span>
        <span style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.65)' }}>{rightLimit}</span>
      </div>
    </div>
  );
};

export default function Profile(props) {
  // constructor(props) {
  //   super(props);

  //   this.state = {
  //     // redirect: null,
  //     userReady: false,
  //     currentUser: { email: "" }
  //   };
  // }

  const [currentUser, setCurrentUser] = useState({});
  const { setValue } = useForm();
  const [rowData, setRowData] = useState([]);
  const [userInvoicesRowData, setUserInvoicesRowData] = useState([]);
  const navigate = useNavigate();



  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [twoFactorSetupData, setTwoFactorSetupData] = useState(null);
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [twoFactorLoading, setTwoFactorLoading] = useState(false);

  const [gridApi, setGridApi] = useState(null);
  const pagination = true;
  const paginationPageSize = 10;
  const { t } = useTranslation();

  useEffect(() => {

    var usr = useStore.getState().loggedInUser;
    setCurrentUser(usr)
    setValue("userId", usr.myDataUserId);
    setValue("token", usr.myDataToken);
    get2FAStatus().then(resp => setTwoFactorEnabled(resp.enabled)).catch(() => {});

    ApiClient.getUserTransactions().then(
      response => {
        if (response) {
          setRowData(response.data)
        }
      },
      error => {
        console.error(error.data)
      }
    )

    ApiClient.getUserInvoicesFromTimologic().then(
      response => {
        if (response) {
          console.log(response.data)
          setUserInvoicesRowData(response.data)
        }
      },
      error => {
        console.error(error.data)
      }
    )
    // if (this.state.redirect) {
    //   return <Redirect to={this.state.redirect} />
    // }
  }, []);


  const onGridReady = params => {
    setGridApi(params.api);
    // params.api.sizeColumnsToFit();
    window.addEventListener('resize', function () {
      setTimeout(function () {
        // params.api.sizeColumnsToFit();
      });
    });

    // params.api.sizeColumnsToFit();
  };
  const onQuickFilterChanged = e => {
    gridApi.setQuickFilter(e.target.value);
  };



  const cancelAccount = () => {


    CustomConfirmAlert({
      title: t("submitConfirm"),
      message: t("confirmCancelAccount"),
      closeOnEscape: false,
      closeOnClickOutside: false,
      buttons: [
        {
          label: t("Ok"),
          onClick: () => {

            ApiClient.cancelAccount().then(
              (response) => {
                console.log(response)
                localStorage.removeItem("user");
                localStorage.removeItem("wizard");
                window.location = "login";
              },
              error => {
                console.error(
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString())
              }
            )
          },
        },
        {
          label: t('cancel')
        }
      ]
    });


  }

  const cancelSubscription = () => {


    CustomConfirmAlert({
      title: t("submitConfirm"),
      message: t("confirmCancelSubscription"),
      closeOnEscape: false,
      closeOnClickOutside: false,
      buttons: [
        {
          label: t("Ok"),
          onClick: () => {

            ApiClient.cancelSubscription().then(
              (response) => {
                toast.success(t("subscriptionCanceled"))
              },
              error => {
                console.error(
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString())
              }
            )
          },
        },
        {
          label: t('cancel')
        }
      ]
    });


  }

  const handleSetup2FA = () => {
    setTwoFactorLoading(true);
    setup2FA()
      .then(resp => { setTwoFactorSetupData(resp); setTwoFactorLoading(false); })
      .catch(err => { console.error(err); setTwoFactorLoading(false); toast.error("Error"); });
  };

  const handleEnable2FA = () => {
    setTwoFactorLoading(true);
    enable2FA(twoFactorCode)
      .then(() => {
        setTwoFactorEnabled(true);
        setTwoFactorSetupData(null);
        setTwoFactorCode("");
        setTwoFactorLoading(false);
        toast.success(t("twoFactorEnabled"));
      })
      .catch(err => { console.error(err); setTwoFactorLoading(false); toast.error(t("Invalid 2FA code")); });
  };

  const handleDisable2FA = () => {
    setTwoFactorLoading(true);
    disable2FA()
      .then(() => { setTwoFactorEnabled(false); setTwoFactorLoading(false); toast.success(t("twoFactorDisabled")); })
      .catch(err => { console.error(err); setTwoFactorLoading(false); });
  };

  const clearCacheAndLogout = () => {
    localStorage.clear();
    logout();
  }

  const toogleApiKeyVisibility = () => {
    var x = document.getElementById("api_key_input");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }

  const currentPkg = currentUser.currentPaymentPackage;
  const statusVariant = currentUser.userStatus === 'ACTIVE' ? 'success'
    : currentUser.userStatus === 'NOT_PAID' ? 'danger' : 'secondary';

  return (
    <div className="container salesContainer profile-page">
      {/* Page header */}
      <header className="profile-header">
        <h5 className="subtitle skin mb-0">
          <i className="fa fa-user-circle" style={{ marginRight: 8 }}></i>
          {t("profile")}
        </h5>
      </header>

      <div className="p-3">
        {/* Top row: user info + package */}
        <div className="row g-3 mb-3">

          {/* User info card */}
          <div className="col-md-6">
            <div className="profile-info-card h-100">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className="profile-avatar">
                  <i className="fa fa-user"></i>
                </div>
                <div className="flex-grow-1">
                  <p className="profile-name">{currentUser.name}</p>
                  <p className="profile-email">{currentUser.email}</p>
                </div>
                <span className={`badge bg-${statusVariant} profile-status-badge`}>
                  {currentUser.userStatus || '—'}
                </span>
              </div>

              <div className="profile-section-label">{t("apiKey")}</div>
              <div className="input-group">
                <input id="api_key_input" className="form-control" defaultValue={currentUser.apiKey} type="password" style={{ borderRadius: '8px 0 0 8px', fontSize: '0.85rem' }} />
                <button className="btn btn-skin" onClick={toogleApiKeyVisibility} style={{ borderRadius: '0 8px 8px 0' }}>
                  <i className="fa fa-eye"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Package card */}
          <div className="col-md-6">
            <div className="package-card h-100">
              <p className="package-card-label">
                <i className="fa fa-cube" style={{ marginRight: 5 }}></i>
                {t("subscriptionPlan")}
              </p>
              <p className="package-card-name">{currentPkg?.id || currentUser.userStatus || '—'}</p>
              {currentPkg?.amount != null && (
                <>
                  <p className="package-card-price">
                    <sup>€</sup>{parseFloat(currentPkg.amount/100).toFixed(2)}
                  </p>
                  <p className="package-card-period">{t("perMonth")}</p>
                </>
              )}
              {currentPkg?.rightLimit != null && (
                <p className="package-card-period">
                  <i className="fa fa-file-text-o" style={{ marginRight: 5 }}></i>
                  {t("upToInvoices", { count: currentPkg.rightLimit })}
                </p>
              )}
              <PackageProgressBar
                leftLimit={currentPkg?.leftLimit}
                rightLimit={currentPkg?.rightLimit}
                currentCount={currentUser.monthInvoiceCounter || 0}
              />
              {currentUser.lastTransactionDate && (
                <p className="package-card-meta">
                  <i className="fa fa-calendar" style={{ marginRight: 5 }}></i>
                  {t("lastPayment")}: {moment(currentUser.lastTransactionDate).format('DD/MM/YYYY')}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="profile-tabs-area">
          <Tabs defaultActiveKey="userInvoicesFromTimologic" id="profile-tabs" className="mb-3">

            <Tab eventKey="userInvoicesFromTimologic" title={t("userInvoicesFromTimologic")}>
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <AgGridReact
                  pagination={pagination}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                  rowData={userInvoicesRowData}
                  columnDefs={[
                    { flex: 2, headerName: t("issuerDate"), cellRenderer: DateRenderer, sortable: true, filter: "agTextColumnFilter", field: "invoiceDate" },
                    { flex: 1, headerName: t("Actions"), cellRenderer: ActionsRenderer, field: "action", cellRendererParams: { action: "edit", hangleEdit: (p) => window.open("mydata/" + p.node.data.invoiceUid, '_blank').focus() } }
                  ]}
                />
              </div>
            </Tab>

            <Tab eventKey="userTransactions" title={t("userTransactions")}>
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <AgGridReact
                  pagination={pagination}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                  rowData={rowData}
                  columnDefs={[
                    { flex: 2, headerName: t("transactionId"), sortable: true, filter: "agTextColumnFilter", field: "transactionId" },
                    { flex: 2, headerName: t("transactionDate"), cellRenderer: DateRenderer, sortable: true, filter: "agTextColumnFilter", field: "transactionDate" },
                    { flex: 1, headerName: t("Amount"), sortable: true, filter: "agTextColumnFilter", field: "amount" },
                    { flex: 1, headerName: t("monthInvoiceCounter"), sortable: true, filter: "agTextColumnFilter", field: "monthInvoiceCounter" },
                    { flex: 1, headerName: t("Actions"), cellRenderer: ActionsRenderer, field: "name", cellRendererParams: { action: "edit", hangleEdit: (p) => window.open(VIVA_VIEW_TRANSACTION + "/web/receipt?tid=" + p.node.data.transactionId, '_blank').focus() } }
                  ]}
                />
              </div>
            </Tab>

            <Tab eventKey="security" title={t("security")}>
              <div className="card p-4" style={{ maxWidth: 500 }}>
                <h6 className="mb-3">
                  <i className="fa fa-shield" style={{ marginRight: 6 }}></i>
                  {t("twoFactorAuth")}
                </h6>

                {twoFactorEnabled ? (
                  <div>
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <span className="badge bg-success">
                        <i className="fa fa-check" style={{ marginRight: 4 }}></i>{t("active")}
                      </span>
                      <span className="text-muted" style={{ fontSize: '0.9rem' }}>{t("twoFactorAuthActive")}</span>
                    </div>
                    <button className="btn btn-sm btn-outline-danger" onClick={handleDisable2FA} disabled={twoFactorLoading}>
                      {t("disable2FA")}
                    </button>
                  </div>
                ) : twoFactorSetupData ? (
                  <div>
                    <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>{t("scanQrCode")}</p>
                    <div className="text-center mb-3">
                      <QRCodeSVG value={twoFactorSetupData.qrCodeUri} size={180} />
                    </div>
                    <p className="text-muted mb-3" style={{ fontSize: '0.8rem' }}>
                      {t("orEnterManually")}: <code style={{ wordBreak: 'break-all' }}>{twoFactorSetupData.secret}</code>
                    </p>
                    <p className="mb-2" style={{ fontSize: '0.9rem' }}>{t("twoFactorEnterCode")}</p>
                    <div className="d-flex gap-2">
                      <input type="text" className="form-control" placeholder="000000"
                        maxLength={6} value={twoFactorCode}
                        onChange={e => setTwoFactorCode(e.target.value.replace(/\D/g, ''))}
                        style={{ maxWidth: 140, letterSpacing: 4, textAlign: 'center' }} />
                      <button className="btn btn-skin" onClick={handleEnable2FA}
                        disabled={twoFactorLoading || twoFactorCode.length !== 6}>
                        {t("confirm")}
                      </button>
                      <button className="btn btn-outline-secondary" onClick={() => { setTwoFactorSetupData(null); setTwoFactorCode(""); }}
                        disabled={twoFactorLoading}>
                        {t("cancel")}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>{t("twoFactorAuthDescription")}</p>
                    <button className="btn btn-skin" onClick={handleSetup2FA} disabled={twoFactorLoading}>
                      {t("enable2FA")}
                    </button>
                  </div>
                )}
              </div>
            </Tab>

          </Tabs>
        </div>

        {/* Danger zone */}
        <div className="profile-danger-zone">
          <p className="profile-danger-title">
            <i className="fa fa-exclamation-triangle" style={{ marginRight: 6 }}></i>
            {t("dangerZone")}
          </p>
          <div className="d-flex gap-3">
            <button className="btn btn-sm btn-outline-danger" onClick={cancelSubscription}>{t("cancelSubscription")}</button>
            <button className="btn btn-sm btn-danger" onClick={cancelAccount}>{t("cancelAccount")}</button>
            <button className="btn btn-sm btn-outline-secondary" onClick={clearCacheAndLogout}>
              <i className="fa fa-sign-out" style={{ marginRight: 5 }}></i>
              {t("clearCacheAndLogout")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
